module.exports = __webpack_public_path__ + "img/new_56.807006c4.jpg";